import { render, staticRenderFns } from "./bank-card.vue?vue&type=template&id=02061422&scoped=true&"
import script from "./bank-card.vue?vue&type=script&lang=js&"
export * from "./bank-card.vue?vue&type=script&lang=js&"
import style0 from "./bank-card.vue?vue&type=style&index=0&id=02061422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02061422",
  null
  
)

export default component.exports